import { widgetSetupSelector } from "../widgetSetupSelector";
import { WidgetType } from "../../../../../services/cloudchipr.api";
import { RootState } from "../../../../store";

export const widgetSetupWidgetTypeSelector = (
  state: RootState,
): WidgetType | undefined => {
  return widgetSetupSelector(state)?.widgetType;
};
